module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-image",
    class: {
      hover: _vm.state === 'editor'
    }
  }, [(!_vm.part.content && _vm.state === 'editor') ? _c('dropzone', {
    on: {
      "upload": _vm.update
    }
  }) : _vm._e(), _vm._v(" "), (_vm.part.content && _vm.state !== 'preview') ? _c('span', [_c('i', {
    staticClass: "icon icon-edit",
    on: {
      "click": function($event) {
        _vm.resetDropzone()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.part.content) ? _c('img', {
    class: {
      'preview': _vm.state === 'preview'
    },
    attrs: {
      "src": _vm.part.content
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-090613d1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/image.vue
// module id = 502
// module chunks = 0